<div id="app-feedback-display-sd" class="container d-flex flex-column flex-grow-1 pt-4 pb-4 h-100" role="main"
    [attr.aria-label]="('FEEDBACKDISPLAY' | translate)">
    <div class="custom-scrollbar overflow-y-auto mb-3">
        <!-- Title, description and attachments -->
        <div class="card mb-3">
            <div class="card-body p-card">
                <div class="my-3 text-center">
                    <div
                        class="no-content-large-icon bg-lightpurple rounded-circle d-flex justify-content-center align-items-center mx-auto">
                        <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                            [fontColor]="'text-white'"></app-icon-badge>
                    </div>
                    <div class="company-logo d-flex justify-content-center align-items-center mx-auto">
                        <img [src]="'https://www.humanstars.app/app/uploads/2020/05/HUMANSTARSapp_RGB_gruen.png'"
                            [width]="250" [height]="53" [alt]="('CUSTOMERIMAGE' | translate)" class="img-fluid"
                            priority appNgSrcImageError />
                    </div>
                    <div class="mt-3">
                        <app-headline [title]="'FEEDBACKDISPLAYTITLE'" [type]="'h5'"
                            [class]="'card-title'"></app-headline>
                    </div>
                </div>
                <div class="d-flex flex-column p-3 mt-5 mb-3">
                    <app-headline
                        [title]="'Evaluate management efficiency by completing this survey, lorem ipsum dolor.'"
                        [type]="'h5'" [class]="'text-primary fw-bold'"></app-headline>
                    <div class="mt-2">
                        <app-content [type]="'richtext'" [expandable]="false"
                            [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'"></app-content>
                    </div>
                    <div class="d-flex flex-wrap gap-2 my-3 uploadedFilesContainer">
                        PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT
                        IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND
                        UNDER THIS TEXT
                        <!--<ng-container *ngFor="let file of files; let i = index">
                          <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                        </ng-container>-->
                    </div>
                    <div class="mt-5 d-flex align-items-center justify-content-center">
                        <!-- If no progress so you start it from the beginning -->
                        <app-form-button [text]="'FEEDBACKSTARTBUTTON' | translate" (click)="startFeedback()"
                            [cssClass]="'e-lightpurple e-small mt-1 fs-default fw-semibold'"></app-form-button>
                        <!-- If user want's to continue -->
                        <app-form-button [text]="'FEEDBACKCONTINUEBUTTON' | translate" (click)="startFeedback()"
                            [cssClass]="'e-warning e-small mt-1 fs-default fw-semibold'"></app-form-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Question with One at a time option -->
        <div class="card mb-3">
            <div class="card-header text-center">
                <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">Question
                    1/13</app-content>
            </div>
            <div class="card-body">
                <!--RADIO add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings-->
                <div class="one-at-atime d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
                    [class.fade-out]="!isVisibleQuestion">
                    <div class="question-title d-flex align-items-center gap-2">
                        <span class="badge rounded-pill bg-primary border text-white fs-default">1</span>
                        <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                            [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
                    </div>
                    <!-- Description of the question -->
                    <div class="question-description d-flex">
                        <app-content [type]="'richtext'"
                            [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                    </div>
                    <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                        PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT
                        IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND
                        UNDER THIS TEXT
                        <!--<ng-container *ngFor="let file of files; let i = index">
                        <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                    </ng-container>-->
                    </div>
                    <!-- Main Question Form Container -->
                    <div class="d-flex flex-column ps-md-3">
                        <div class="d-flex flex-column">
                            <div class="mt-2">
                                <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mt-2">
                                <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                    </div>
                    <!-- If requires mandatory comment -->
                    <div class="d-flex flex-column mt-3 ps-md-3 w-100">
                        <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                        <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                            [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                            [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-end">
                    <div class="d-flex align-items-center gap-2">
                        <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                            [title]="'FEEDBACKTIMELEFTTOANSWER' | translate"></app-headline>
                        <app-headline [type]="'h5'" [class]="'text-danger fw-bold'" [title]="'20s'"></app-headline>
                    </div>
                    <app-form-button [text]="'NEXT' | translate" (click)="true"
                        [cssClass]="'e-primary ms-auto w-25'"></app-form-button>
                </div>
            </div>
        </div>

        <!-- Question 1 with Multicard option -->
        <div class="card mb-3">
            <div class="card-body">
                <!--RADIO add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings-->
                <div class="multicard-display d-flex align-items-start flex-column">
                    <div class="question-title d-flex align-items-center gap-2">
                        <span class="badge rounded-pill bg-primary border text-white fs-default">1</span>
                        <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                            [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
                    </div>
                    <!-- Description of the question -->
                    <div class="question-description d-flex">
                        <app-content [type]="'richtext'"
                            [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                    </div>
                    <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                        PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT
                        IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND
                        UNDER THIS TEXT
                        <!--<ng-container *ngFor="let file of files; let i = index">
                        <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                    </ng-container>-->
                    </div>
                    <!-- Main Question Form Container -->
                    <div class="d-flex flex-column ps-md-3">
                        <div class="d-flex flex-column">
                            <div class="mt-2">
                                <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mt-2">
                                <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                    </div>
                    <!-- If requires mandatory comment -->
                    <div class="d-flex flex-column mt-3 ps-md-3 w-100">
                        <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                        <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                            [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                            [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
                    </div>
                </div>
            </div>
        </div>
        <!-- Question 2 with Multicard option, has the FINISH Button-->
        <div class="card mb-3">
            <div class="card-body">
                <!--IMAGE CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
                <div class="multicard-display d-flex align-items-start flex-column">
                    <div class="question-title  d-flex align-items-center gap-2">
                        <span class="badge rounded-pill bg-primary border text-white fs-default">2</span>
                        <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                            [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
                    </div>
                    <!-- Description of the question -->
                    <div class="question-description d-flex">
                        <app-content [type]="'richtext'"
                            [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                    </div>
                    <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                        PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT
                        IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND
                        UNDER THIS TEXT
                        <!--<ng-container *ngFor="let file of files; let i = index">
                        <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                    </ng-container>-->
                    </div>
                    <!-- Main Question Form Container -->
                    <div class="d-flex flex-column w-100">
                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">

                            <!-- Tile 1 -->
                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                <div
                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                    <img src="https://www.shutterstock.com/image-vector/survey-form-pencil-vector-illustration-600nw-2656414333.jpg"
                                        alt="Sample Image" appNgSrcImageError>
                                </div>

                                <div class="d-flex flex-column align-items-center">
                                    <div
                                        class="image-radio-selector d-flex align-items-center justify-content-center pe-3 pb-1 lh-1 border">
                                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                            [cssClass]="'e-large mb-3'"></app-form-radio>
                                    </div>

                                    <div class="d-flex mt-2 p-1">
                                        <app-form-label
                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                    </div>
                                </div>
                            </div>

                            <!-- Tile 2 -->
                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                <div
                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                        alt="Sample Image" appNgSrcImageError>
                                </div>

                                <div class="d-flex flex-column align-items-center">
                                    <div
                                        class="image-radio-selector d-flex align-items-center justify-content-center pe-3 pb-1 lh-1 border">
                                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                    </div>

                                    <div class="d-flex mt-2 p-1">
                                        <app-form-label
                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                    </div>
                                </div>
                            </div>

                            <!-- Tile 3 -->
                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                <div
                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                        alt="Sample Image" appNgSrcImageError>
                                </div>

                                <div class="d-flex flex-column align-items-center">
                                    <div
                                        class="image-radio-selector d-flex align-items-center justify-content-center pe-3 pb-1 lh-1 border">
                                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                    </div>

                                    <div class="d-flex mt-2 p-1">
                                        <app-form-label
                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- If requires mandatory comment -->
                        <div class="d-flex flex-column my-3">
                            <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                            <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                [fCN]="'feedback_comment'" [fG]="feedbackForm" [maxChars]="200"
                                [rows]="4"></app-form-textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-end">
                    <app-form-button [text]="'FEEDBACKFINISHSURVEYBUTTON' | translate" (click)="true"
                        [cssClass]="'e-primary ms-auto w-25'"></app-form-button>
                </div>
            </div>
        </div>

        <!-- Question with One Form Display -->
        <div class="card mb-3">
            <div class="card-body">
                <!--RADIO add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings-->
                <div class="oneform-display d-flex align-items-start flex-column">
                    <div class="question-title d-flex align-items-center gap-2">
                        <span class="badge rounded-pill bg-primary border text-white fs-default">1</span>
                        <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                            [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
                    </div>
                    <!-- Description of the question -->
                    <div class="question-description d-flex">
                        <app-content [type]="'richtext'"
                            [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                    </div>
                    <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                        PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT
                        IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND
                        UNDER THIS TEXT
                        <!--<ng-container *ngFor="let file of files; let i = index">
                        <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                    </ng-container>-->
                    </div>
                    <!-- Main Question Form Container -->
                    <div class="d-flex flex-column ps-md-3">
                        <div class="d-flex flex-column">
                            <div class="mt-2">
                                <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mt-2">
                                <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="mt-2 mb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="'This is the radio dynamic label'"
                                    [cssClass]="'e-large'"></app-form-radio>
                            </div>
                        </div>
                    </div>
                    <!-- If requires mandatory comment -->
                    <div class="d-flex flex-column mt-3 ps-md-3 w-100">
                        <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                        <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                            [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                            [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
                    </div>
                </div>

                <!--IMAGE CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
                <div class="oneform-display d-flex align-items-start flex-column">
                    <div class="question-title  d-flex align-items-center gap-2">
                        <span class="badge rounded-pill bg-primary border text-white fs-default">2</span>
                        <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                            [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
                    </div>
                    <!-- Description of the question -->
                    <div class="question-description d-flex">
                        <app-content [type]="'richtext'"
                            [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                    </div>
                    <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                        PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT
                        IS MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND
                        UNDER THIS TEXT
                        <!--<ng-container *ngFor="let file of files; let i = index">
                        <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                    </ng-container>-->
                    </div>
                    <!-- Main Question Form Container -->
                    <div class="d-flex flex-column w-100">
                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">

                            <!-- Tile 1 -->
                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                <div
                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                    <img src="https://www.shutterstock.com/image-vector/survey-form-pencil-vector-illustration-600nw-2656414333.jpg"
                                        alt="Sample Image" appNgSrcImageError>
                                </div>

                                <div class="d-flex flex-column align-items-center">
                                    <div
                                        class="image-radio-selector d-flex align-items-center justify-content-center pe-3 pb-1 lh-1 border">
                                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                            [cssClass]="'e-large mb-3'"></app-form-radio>
                                    </div>

                                    <div class="d-flex mt-2 p-1">
                                        <app-form-label
                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                    </div>
                                </div>
                            </div>

                            <!-- Tile 2 -->
                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                <div
                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                        alt="Sample Image" appNgSrcImageError>
                                </div>

                                <div class="d-flex flex-column align-items-center">
                                    <div
                                        class="image-radio-selector d-flex align-items-center justify-content-center pe-3 pb-1 lh-1 border">
                                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                    </div>

                                    <div class="d-flex mt-2 p-1">
                                        <app-form-label
                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                    </div>
                                </div>
                            </div>

                            <!-- Tile 3 -->
                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                <div
                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                        alt="Sample Image" appNgSrcImageError>
                                </div>

                                <div class="d-flex flex-column align-items-center">
                                    <div
                                        class="image-radio-selector d-flex align-items-center justify-content-center pe-3 pb-1 lh-1 border">
                                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                    </div>

                                    <div class="d-flex mt-2 p-1">
                                        <app-form-label
                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- If requires mandatory comment -->
                        <div class="d-flex flex-column my-3">
                            <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                            <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                [fCN]="'feedback_comment'" [fG]="feedbackForm" [maxChars]="200"
                                [rows]="4"></app-form-textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-end">
                    <app-form-button [text]="'FEEDBACKFINISHSURVEYBUTTON' | translate" (click)="true"
                        [cssClass]="'e-primary ms-auto w-25'"></app-form-button>
                </div>
            </div>
        </div>

        <!-- SCORE DISPLAY -->
        <div class="card mb-3">
            <div class="card-body">
                <!-- SCORE 1-->
                <div class="d-flex align-items-start flex-column my-3 w-100">
                    <div class="card w-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-center align-items-center flex-wrap my-5 gap-2">
                                <app-headline [title]="'FEEDBACKSCORERESULT' | translate" [type]="'h5'"
                                    [class]="'text-primary fw-bold'"></app-headline>
                                <app-headline [title]="'128'" [type]="'h5'"
                                    [class]="'text-primary fw-bold'"></app-headline>
                                <app-headline [title]="'FEEDBACKSCOREPREFIX' | translate" [type]="'h5'"
                                    [class]="'text-primary fw-bold'"></app-headline>
                            </div>
                            <app-content [type]="'richtext'" [expandable]="false"
                                [innerHTML]="'<h5>CONGRATULATIONS!</h5></br><p>It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>'"></app-content>
                        </div>
                    </div>
                </div>

                <!-- SCORE 2-->
                <div class="d-flex align-items-start flex-column my-3 w-100">
                    <div class="card w-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-center align-items-center flex-wrap my-5 gap-2">
                                <app-headline [title]="'FEEDBACKSCORERESULT' | translate" [type]="'h5'"
                                    [class]="'text-danger fw-bold'"></app-headline>
                                <app-headline [title]="'128'" [type]="'h5'"
                                    [class]="'text-danger fw-bold'"></app-headline>
                                <app-headline [title]="'FEEDBACKSCOREPREFIX' | translate" [type]="'h5'"
                                    [class]="'text-danger fw-bold'"></app-headline>
                            </div>
                            <app-content [type]="'richtext'" [expandable]="false"
                                [innerHTML]="'<h5>WE ARE SORRY!</h5></br><p>It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>'"></app-content>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>